module.exports = __webpack_public_path__ + "img/module0.88c6e1ba.png";